import User from '@/models/User'

export default {
  computed: {
    $currentUser() {
      const email = this.$auth?.profile?.email
      if (!email) return

      return User.query()
        .with('permissions')
        .where('email', email)
        .first()
    },
  },
}
